const pageNameKey = "otaFirmwareUploadModal";

export const otaFirmwareUploadModalEn = {
  [pageNameKey]: {
    uploadingFirmwareText: "Uploading your firmware",
    descriptionStartText:
      "This may take a moment. Please do not close this window or refresh the page while the firmware is being uploaded.",
    helperText: "Firmware package is being verified and prepared for release.",
    uploadingFirmware: "Uploading Firmware",

    firmwareUploadFailedText: "Firmware upload failed",
    descriptionFailedText:
      "Something went wrong while uploading the firmware. Please try again.",
    helperFailedText:
      "The upload process was interrupted or the server returned an error. Please retry the upload.",

    firmwareUploadSuccessText: "Firmware uploaded successfully",
    descriptionSuccessText:
      "Your firmware has been uploaded and is ready to be used.",
    helperSuccessText:
      "The firmware package has been verified and stored successfully.",
    fileText: "File",
    sizeText: "Size",
  },
};

export const otaFirmwareUploadModalPtBr = {
  [pageNameKey]: {
    uploadingFirmwareText: "Enviando seu firmware",
    descriptionStartText:
      "Isso pode levar alguns instantes. Não feche esta janela nem atualize a página enquanto o firmware estiver sendo carregado.",
    helperText:
      "O pacote de firmware está sendo verificado e preparado para lançamento.",
    uploadingFirmware: "Enviando firmware",

    firmwareUploadFailedText: "Falha no upload do firmware",
    descriptionFailedText:
      "Algo deu errado ao enviar o firmware. Tente novamente.",
    helperFailedText:
      "O processo de upload foi interrompido ou o servidor retornou um erro. Tente enviar o arquivo novamente.",

    firmwareUploadSuccessText: "Firmware enviado com sucesso",
    descriptionSuccessText:
      "Seu firmware foi enviado e está pronto para ser usado.",
    helperSuccessText:
      "O pacote de firmware foi verificado e armazenado com sucesso.",
    fileText: "Arquivo",
    sizeText: "Tamanho",
  },
};

export const otaFirmwareUploadModalDe = {
  [pageNameKey]: {
    uploadingFirmwareText: "Firmware wird hochgeladen",
    descriptionStartText:
      "Dies kann einen Moment dauern. Bitte schließen Sie dieses Fenster nicht und aktualisieren Sie die Seite nicht, während die Firmware hochgeladen wird.",
    helperText:
      "Das Firmware-Paket wird überprüft und für die Veröffentlichung vorbereitet.",
    uploadingFirmware: "Firmware wird hochgeladen",

    firmwareUploadFailedText: "Firmware-Upload fehlgeschlagen",
    descriptionFailedText:
      "Beim Hochladen der Firmware ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
    helperFailedText:
      "Der Upload-Vorgang wurde unterbrochen oder der Server hat einen Fehler zurückgegeben. Bitte laden Sie die Firmware erneut hoch.",

    firmwareUploadSuccessText: "Firmware erfolgreich hochgeladen",
    descriptionSuccessText:
      "Ihre Firmware wurde hochgeladen und kann nun verwendet werden.",
    helperSuccessText:
      "Das Firmware-Paket wurde erfolgreich überprüft und gespeichert.",
    fileText: "Datei",
    sizeText: "Größe",
  },
};

export const otaFirmwareUploadModalZhHans = {
  [pageNameKey]: {
    uploadingFirmwareText: "正在上传固件",
    descriptionStartText:
      "这可能需要一点时间。在固件上传过程中，请不要关闭此窗口或刷新页面。",
    helperText: "固件包正在验证并准备发布。",
    uploadingFirmware: "正在上传固件",

    firmwareUploadFailedText: "固件上传失败",
    descriptionFailedText: "上传固件时出现错误。请重试。",
    helperFailedText: "上传过程被中断或服务器返回错误。请重新上传固件。",

    firmwareUploadSuccessText: "固件上传成功",
    descriptionSuccessText: "您的固件已成功上传并可以使用。",
    helperSuccessText: "固件包已成功验证并存储。",
    fileText: "文件",
    sizeText: "大小",
  },
};

export const otaFirmwareUploadModalIt = {
  [pageNameKey]: {
    uploadingFirmwareText: "Caricamento del firmware",
    descriptionStartText:
      "L'operazione potrebbe richiedere qualche minuto. Si prega di non chiudere questa finestra o ricaricare la pagina mentre il firmware viene caricato.",
    helperText:
      "Il pacchetto firmware viene verificato e preparato per il rilascio.",
    uploadingFirmware: "Caricamento firmware",

    firmwareUploadFailedText: "Fallito l'upload del firmware",
    descriptionFailedText:
      "Si è verificato un errore durante il caricamento del firmware. Riprova.",
    helperFailedText:
      "Il processo di caricamento è stato interrotto o il server ha restituito un errore. Riprova il caricamento.",

    firmwareUploadSuccessText: "Firmware caricato con successo",
    descriptionSuccessText:
      "Il tuo firmware è stato caricato ed è pronto per l'uso.",
    helperSuccessText:
      "Il pacchetto firmware è stato verificato e salvato con successo.",
    fileText: "File",
    sizeText: "Dimensione",
  },
};

export const otaFirmwareUploadModalEs = {
  [pageNameKey]: {
    uploadingFirmwareText: "Subiendo tu firmware",
    descriptionStartText:
      "Esto puede tardar un momento. No cierres esta ventana ni actualices la página mientras se carga el firmware.",
    helperText:
      "El paquete de firmware se está verificando y preparando para su lanzamiento.",
    uploadingFirmware: "Cargando firmware",

    firmwareUploadFailedText: "La carga del firmware falló",
    descriptionFailedText:
      "Se produjo un error al cargar el firmware. Inténtalo de nuevo.",
    helperFailedText:
      "El proceso de carga se interrumpió o el servidor devolvió un error. Vuelve a intentarlo.",

    firmwareUploadSuccessText: "Firmware cargado correctamente",
    descriptionSuccessText:
      "Tu firmware se ha cargado y está listo para usarse.",
    helperSuccessText:
      "El paquete de firmware se ha verificado y almacenado correctamente.",
    fileText: "Archivo",
    sizeText: "Tamaño",
  },
};

export const otaFirmwareUploadModalNl = {
  [pageNameKey]: {
    descriptionFailedText:
      "Er is een fout opgetreden tijdens het uploaden van de firmware. Probeer het opnieuw.",
    descriptionStartText:
      "Dit kan even duren. Sluit dit venster niet en vernieuw de pagina niet terwijl de firmware wordt geuploaded.",
    descriptionSuccessText: "Uw firmware is geüpload en klaar voor gebruik.",
    fileText: "Bestand",
    firmwareUploadFailedText: "Uploaden van firmware mislukt",
    firmwareUploadSuccessText: "Firmware succesvol geuploaded",
    helperFailedText:
      "Het uploadproces is onderbroken of de server heeft een fout geretourneerd. Probeer het uploaden opnieuw.",
    helperSuccessText:
      "Het firmwarepakket is geverifieerd en succesvol opgeslagen.",
    helperText: "Firmwarepakket wordt geverifieerd en voorbereid voor uitgave.",
    sizeText: "Grootte",
    uploadingFirmware: "Firmware uploaden",
    uploadingFirmwareText: "Uw firmware uploaden",
  },
};

export const otaFirmwareUploadModalTr = {
  [pageNameKey]: {
    descriptionFailedText:
      "Firmware yüklenirken bir şeyler ters gitti. Lütfen tekrar deneyin.",
    descriptionStartText:
      "Bu biraz zaman alabilir. Firmware yüklenirken lütfen bu pencereyi kapatmayın veya sayfayı yenilemeyin.",
    descriptionSuccessText: "Firmware'iniz yüklendi ve kullanıma hazır.",
    fileText: "Dosya",
    firmwareUploadFailedText: "Donanım yazılımı yüklemesi başarısız oldu",
    firmwareUploadSuccessText: "Donanım yazılımı başarıyla yüklendi",
    helperFailedText:
      "Yükleme işlemi kesintiye uğradı veya sunucu bir hata döndürdü. Lütfen yüklemeyi yeniden deneyin.",
    helperSuccessText: "Firmware paketi doğrulandı ve başarıyla saklandı.",
    helperText: "Firmware paketi doğrulanıyor ve yayına hazırlanıyor.",
    sizeText: "Boyut",
    uploadingFirmware: "Donanım Yazılımının Yüklenmesi",
    uploadingFirmwareText: "Ürün yazılımınızı yükleme",
  },
};
